import { render, staticRenderFns } from "./profile-card.vue?vue&type=template&id=6f125ddf&scoped=true"
import script from "./profile-card.vue?vue&type=script&lang=js"
export * from "./profile-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f125ddf",
  null
  
)

export default component.exports